/** Manual AdSense only — Auto ads disabled in public/index.html. */
export const ADSENSE_CLIENT = 'ca-pub-2534229011090838';
export const ADSENSE_SLOT = '6432932865';

/** Serve ads on the live site only (avoid invalid traffic in local/dev). */
export function isAdSenseEnabled(): boolean {
  // Project tsconfig may omit DOM lib; read hostname via global.
  const g: any = typeof global !== 'undefined' ? global : {};
  const host = (g.window && g.window.location && g.window.location.hostname)
    || (g.location && g.location.hostname)
    || '';
  return host === 'language123.net' || String(host).endsWith('.language123.net');
}
